import ApplicationLogo from "@/Components/UI/Branding/ApplicationLogo";
import { logout } from "@/utils/identity";

export default function CoachIntakeNavbar() {
    return (
        <nav className="sticky top-0 z-20 bg-brand-white shadow w-full">
            <div className="mx-auto px-6 sm:px-8">
                <div className="relative flex h-16 items-center justify-between">
                    <div className="flex shrink-0 items-center">
                        <ApplicationLogo useDark={true} allowClick={true} />
                    </div>

                    <div className="flex items-center">
                        <button
                            onClick={() => void logout()}
                            className="text-sm cursor-pointer rounded-md px-3 py-2 font-medium text-brand-black hover:bg-brand-red hover:text-brand-white active:bg-brand-primaryButtonClick transition-colors duration-150"
                            aria-label="Log out"
                        >
                            Logout
                        </button>
                    </div>
                </div>
            </div>
        </nav>
    );
}
